<template>
  <b-modal
    id="edit-device-modal"
    title="Device Edit Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Device Edit</h2>
    </template>
    <validation-observer ref="deviceEditFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="name">
          <template #label>
            Device ID <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="name"
            v-model="name"
            v-restrict="regex"
            placeholder="Device ID"
            required
          />
        </b-form-group>

        
        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            required
            @input="fetchBuildings()"
          ></v-select>
        </b-form-group>

        <b-form-group label-for="building">
          <template #label>
            Building
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Building"
            :options="buildings"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor
  },
  mixins: [util],
  props: {
    device: Object,
  },
  data() {
    return {
      required,
      name: "",
      regex: /^[a-zA-Z ]*$/,
      site: "",
      sites: [],
      buildings: [],
      building: "",
    };
  },
  async mounted() {
    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings =  await this.getBuildingsDDL();
    this.buildings = buildings.data;
    
    if (this.device) {
      this.name = this.device.name;
      this.site = this.sites.find(ss => ss.id === this.device.site);
      this.buildings = this.buildings.filter(building => building.site === this.device.site); 
      if(this.device.building){
        this.building = this.buildings.filter(building => building.id === this.device.building); 
      }
    }
  },
  methods: {
    ...mapActions({
      updateDevice: "appData/updateDevice",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),
    
    async validationForm() {
      const success = await this.$refs.deviceEditFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const formData = new FormData();
        formData.append("name", this.name);
        formData.append("site", this.site.id);
        if(this.building){
          formData.append("building", this.building.id);
        }
        formData.append('updated_by', this.getLoggedInUser.id); 
        const res = await this.updateDevice({
          payload: formData,
          pk: this.device.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Device Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-device-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      this.building = "";
       if (!this.site) {
        this.buildings = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },


    reset() {
      this.name = "";
      this.site = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style></style>
